type GoogleConsentStatus = {
  ad_storage: 'granted' | 'denied'
  ad_user_data: 'granted' | 'denied'
  ad_personalization: 'granted' | 'denied'
  analytics_storage: 'granted' | 'denied'
}

export const GOOGLE_ADS_ID = 'AW-674753115'

/**
 * Important 1: must not be able to throw an error, as it is called in the store initialization.
 * Important 2: if you change this function, ensure that https://region1.google-analytics.com/g/collect is still being called,
 *  and that the gcs query parameter is still included (the correct value is G111 or G100, depending on the consent).
 * @param hasUserGivenConsent
 */
export const initGtagConsent = (
  hasUserGivenConsent: boolean,
): { updateGtagConsent: (hasConsent: boolean) => void } => {
  try {
    // @ts-expect-error - Using GA4 in client mode with RudderStack requires us to mutate window :(
    window.dataLayer = window.dataLayer ?? getDataLayer()

    // Marks the time the Google tag was initialized (used for event timing/order)
    gtag('js', new Date())
    // Google Ads.
    gtag('config', GOOGLE_ADS_ID, { allow_enhanced_conversions: true })
    // Google Consent.
    gtag('consent', 'default', googleConsentStatus(hasUserGivenConsent))
    const updateGtagConsent = (hasUserGivenConsent: boolean): void => {
      gtag('consent', 'update', googleConsentStatus(hasUserGivenConsent))
    }
    return { updateGtagConsent }
  } catch (_error) {
    return { updateGtagConsent: () => undefined }
  }
}

/**
 * Must be function expression to allow for `arguments` to be used.
 * @param _args - dummy to allow for any number of arguments of any type in TypeScript
 */
export const gtag = function (..._args: unknown[]): void {
  // `arguments` must be used here rather than spread arguments.
  //  I am not sure why, but I think the gtag library might access the non-enumerable property `callee` of `arguments`.

  getDataLayer().push(arguments)
}

const googleConsentStatus = (hasConsent: boolean): GoogleConsentStatus => {
  const statusValue = hasConsent ? 'granted' : 'denied'
  return {
    ad_storage: statusValue,
    ad_user_data: statusValue,
    ad_personalization: statusValue,
    analytics_storage: statusValue,
  }
}

const getDataLayer = (): unknown[] =>
  'dataLayer' in window && window.dataLayer && Array.isArray(window.dataLayer)
    ? window.dataLayer
    : []
